import { z } from "zod";
var roleSchema = z.object({
    id: z.string(),
    name: z.string()
});
export var userSchema = z.object({
    createdDate: z.string(),
    company: z.object({
        name: z.string().nullable(),
        city: z.string().nullable()
    }),
    email: z.string(),
    fullName: z.string(),
    id: z.string(),
    initials: z.string(),
    jobTitle: z.string().optional().nullable(),
    lastUpdated: z.string(),
    phone: z.string(),
    profilePicture: z.string(),
    participantTitle: z.string().optional().nullable(),
    roles: z.union([z.array(roleSchema), z.tuple([])]).optional()
});
export var userListSchema = z.array(userSchema);
export var onSiteUserSchema = z.object({
    sub: z.string(),
    picture: z.string().optional(),
    role: z.union([z.array(z.string()), z.string()]).optional(),
    preferred_username: z.string(),
    name: z.string()
});
//# sourceMappingURL=User.zod.js.map